import { memo, useMemo } from "react";

import { TableContext } from "components/Table/Context";
import TableHead from "ds/components/Table/Head";
import { TableColumnMeta } from "ds/components/Table/types";
import useTypedContext from "hooks/useTypedContext";
import { getHeadColumnKey } from "ds/components/Table/Head/helpers";

import EnvironmentTableColumn from "./EnvironmentTableColumn";

const EnvironmentTableHeader = ({ tableId }: { tableId: string }) => {
  const { mergedColumnsConfig } = useTypedContext(TableContext);
  const columns = useMemo(
    () => Object.values(mergedColumnsConfig) as TableColumnMeta[],
    [mergedColumnsConfig]
  );

  return (
    <TableHead>
      {columns.map((column) => (
        <EnvironmentTableColumn key={getHeadColumnKey(column)} column={column} tableId={tableId} />
      ))}
    </TableHead>
  );
};

export default memo(EnvironmentTableHeader);
